import { StepContainer, StepContent, StepForm, StepHeading, StepNavigator, StepNextButton } from '../../components';
import { OnboardingMachineContext, ProviderIdentityFilterNextData } from '../types';
import { CheckboxesFormRow } from '../../../components/checkboxes-form-row';
import { useEthnicitiesQuery, useFaithsQuery, useGendersQuery } from '@uplift/queries';
import { Formik } from 'formik';
import { transformOnboardingGenderLabels } from '@uplift/pages';

export type ProviderIdentityFilterProps = {
  onNext: (data: ProviderIdentityFilterNextData) => void;
  onBack: () => void;
  identityFilters: OnboardingMachineContext['identityFilters'];
};

export const ProviderIdentityFilter: React.VFC<ProviderIdentityFilterProps> = props => {
  const { data: genders = [] } = useGendersQuery();
  const { data: faiths = [] } = useFaithsQuery();
  const { data: ethnicities = [] } = useEthnicitiesQuery();

  return (
    <Formik
      initialValues={props.identityFilters}
      onSubmit={props.onNext}
    >
      {formik => (
        <StepContainer>
          <StepContent>
            <StepHeading>Provider Identity</StepHeading>
            <StepForm onSubmit={formik.handleSubmit}>
              <CheckboxesFormRow
                name="genderIds"
                title="Gender"
                modalTitle="Provider's Gender"
                options={transformOnboardingGenderLabels(genders)}
                getLabel={opt => opt.name}
                getValue={opt => opt.id}
              />
              <CheckboxesFormRow
                name="faithIds"
                title="Faith"
                modalTitle="Provider's Faith"
                options={faiths}
                getLabel={opt => opt.name}
                getValue={opt => opt.id}
              />
              <CheckboxesFormRow
                name="ethnicityIds"
                title="Ethnicity"
                modalTitle="Provider's Ethnicity"
                options={ethnicities}
                getLabel={opt => opt.name}
                getValue={opt => opt.id}
              />
            </StepForm>
          </StepContent>
          <StepNavigator onBack={props.onBack}>
            <StepNextButton />
          </StepNavigator>
        </StepContainer>
      )}
    </Formik>
  );
};